export default __webpack_public_path__ + "static/media/cloud-sync.cc9d9a3e.svg";